import React, { Fragment, useEffect, useState } from 'react'
import { Dropdown, DropdownButton, SplitButton, ButtonGroup } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import avatar1 from '../../../images/avatar/1.jpg'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { save } from 'save-file'
import * as constants from '../../../utils/Constants'
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse'

const ViewUser = () => {
    const { state, filterDataCallback, searchCallBack, sortByCallBack, orderCallBack,pageCallBack  } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const history = useHistory();
    const backBtn = () => {
        history.push({ pathname: "/list-user", state: "", filterDataCallback: filterDataCallback, searchCallBack: searchCallBack, sortByCallBack: sortByCallBack, orderCallBack: orderCallBack, pageCallBack: pageCallBack  });
    }
    return (
        <Fragment>
            <div className='form-group'>
                <button id="go-back" color="primary" className='btn btn-primary' style={{ backgroundColor: '#00ADEE', border: 'none', marginTop: 0, marginBottom: 0,paddingLeft: '10px',paddingRight: '10px',paddingTop: '4px',paddingBottom:'4px' }} type='button'
                    onClick={() => backBtn()}
                ><i class='fa fa-arrow-circle-o-left' style={{fontSize:'25px'}} /></button>
            </div>
            <div className='row'>
                <div className='col-xl-3 col-xxl-3' />
                <div className='col-xl-6 col-xxl-6'>
                    <div className='row'>
                        <div className='col-xl-12 col-lg-6'>
                            <div className='card flex-lg-column flex-md-row'>
                                <div className="">
                                    <div className='card-body card-body text-center border-bottom profile-bx'>
                                        <div className='profile-image mb-4'>
                                            <img src={avatar1} className='rounded-circle' alt />
                                        </div>
                                        <p className='fs-22 text-black mb-1'>{state.userName}</p>
                                        <p className='mb-4'>{state.roles}</p>
                                        <p className='mb-4'>{state?.employeeId !== 'null' ? state.employeeId : ''}</p>
                                        <p className='mb-4'>{state?.activeFlag === 0 ? 'Active' : 'Inactive'}</p>

                                        <Link className='btn btn-primary btn-md'
                                            style={{ backgroundColor: '#00ADEE', textAlign: 'center', border: 'none' }}
                                            to={{
                                                pathname: "/create-user",
                                                state: state
                                            }}
                                        >
                                            <i className='fa fa-edit mr-2' />
                                            Edit Candidate
                                        </Link>
                                    </div>
                                    <div className='card-body  border-left row'>
                                        <div className='d-flex mb-3 align-items-center'>
                                            <a className='contact-icon mr-3' href='#'>
                                                <i className='las la-envelope' />
                                            </a>
                                            <span className='text-black'>{state.emailId}</span>
                                        </div> &nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-xl-3 col-xxl-3' />
        </Fragment >
    )
}

export default ViewUser;